import { render, staticRenderFns } from "./PasswordUpdate.vue?vue&type=template&id=fc2f186a&scoped=true"
import script from "./PasswordUpdate.vue?vue&type=script&lang=js"
export * from "./PasswordUpdate.vue?vue&type=script&lang=js"
import style0 from "./PasswordUpdate.vue?vue&type=style&index=0&id=fc2f186a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2f186a",
  null
  
)

export default component.exports